import {Injectable} from '@angular/core';
import {get, ref, set} from 'firebase/database';
import {firebaseDb} from 'app/blocks/service/firebase-app';
import {BehaviorSubject, Subject} from 'rxjs';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {Principal} from 'app/core/auth/principal.service';
import {UnsubscribeDirective} from 'app/common/unsubscribe.directive';
import {environment} from 'environments/environment';
import {ServerEventService} from 'app/blocks/service/server-event.service';
import {parse} from 'path';

@Injectable({
    providedIn: 'root'
})
export class LoggedInService extends UnsubscribeDirective {
    public loggedInData = new BehaviorSubject<any>([]);
    private readonly db = firebaseDb();

    constructor(private serverEventService: ServerEventService) {
        super();
        this.serverEventService.loggedInCount.pipe(debounceTime(1000)).subscribe((data) => {
            this.updateLogin();
        });
        this.serverEventService.identity.subscribe((data) => {
            this.updateLogin();
        });
    }

    updateLogin() {
        const login = this.formatUserId(this.serverEventService.identity.getValue().login);
        if (login && this.serverEventService.identity.getValue().tenantId) {
            set(
                ref(
                    this.db,
                    environment.firebaseConfig.env + '/events/' + this.serverEventService.identity.getValue().tenantId + '/loggedInData/' + login
                ),
                Math.floor(Date.now() / 1000)
            );
            get(
                ref(this.db, environment.firebaseConfig.env + '/events/' + this.serverEventService.identity.getValue().tenantId + '/loggedInData')
            ).then((snapshot) => {
                const data = snapshot.val();
                const result = [];
                for (const key of Object.keys(data)) {
                    result.push({
                        user: key,
                        lastLogin: this.formatTimestamp(parseInt(data[key]))
                    });
                }
                this.loggedInData.next(result);
            });
        }
    }

    formatUserId(userId: string): string {
        if (!userId) return userId;
        return userId.replace(/[.#$\[\]]/g, '_');
    }

    formatTimestamp(timestamp: number): string {
        const date = new Date(timestamp * 1000);
        const day = this.padZero(date.getDate());
        const month = this.padZero(date.getMonth() + 1);
        const year = date.getFullYear().toString().slice(-2);
        const hours = this.padZero(date.getHours());
        const minutes = this.padZero(date.getMinutes());
        return `${day}/${month}/${year}:${hours}:${minutes}`;
    }

    padZero(num: number): string {
        return num < 10 ? '0' + num : num.toString();
    }
}
